import { connect } from 'react-redux';
import autobind from 'core-decorators/lib/autobind';
import { VODCSSModules } from 'shared/utils/wix-connect';

import { getVideosGroupedByIds } from 'shared/selectors/videos';
import { getCurrentSiteUser } from 'widget/selectors/current-site-user';

import ContentSlider from 'widget/views/desktop/compact/components/content-slider/content-slider';
import PageList from 'widget/views/desktop/compact/components/page-list/page-list';
import Nav from 'widget/components/nav/nav';
import VideoListItem from 'widget/views/desktop/compact/components/videos/video-list-item/video-list-item';

import styles from './videos.styl';


@connect(state => ({
  videoByIds: getVideosGroupedByIds(state),
  currentSiteUser: getCurrentSiteUser(state),
}))
@VODCSSModules(styles)
export default class Videos extends React.Component {

  static propTypes = {
    OverlayActionsCallbacks: React.PropTypes.func,

    channelData: React.PropTypes.object,
    currentSiteUser: React.PropTypes.object,

    containerWidth: React.PropTypes.number,

    videoByIds: React.PropTypes.object,
    videoIdsByPageNumber: React.PropTypes.array,

    thumbnailSize: React.PropTypes.shape({
      width: React.PropTypes.number,
      height: React.PropTypes.number,
    }),

    onSlideToPrev: React.PropTypes.func,
    onSlideToNext: React.PropTypes.func,

    currentVideosPageNumber: React.PropTypes.number,
  };

  state = {
    isCurrentVideosPageLocked: false,
  };

  @autobind
  renderVideoItem(videoId) {
    const {
      channelData,
      videoByIds,
      thumbnailSize,
      currentSiteUser,
      OverlayActionsCallbacks,
    } = this.props;

    const videoItem = videoByIds[videoId];

    // Fix for css-modules:
    // Need to be separated component with css-modules decorator instead of plain jsx to provide proper styles
    return (
      <VideoListItem {...thumbnailSize}
                     OverlayActionsCallbacks={OverlayActionsCallbacks}
                     channelData={channelData}
                     videoItem={videoItem}
                     currentSiteUser={currentSiteUser}
                     key={videoId} />

    );
  }

  hasPage(pageNum) {
    const { videoIdsByPageNumber } = this.props;
    return Boolean(videoIdsByPageNumber[pageNum]);
  }

  get isPrevPageVisible() {
    const { currentVideosPageNumber } = this.props;
    return this.hasPage(currentVideosPageNumber - 1);
  }

  get isNextPageVisible() {
    const { currentVideosPageNumber } = this.props;
    return this.hasPage(currentVideosPageNumber + 1);
  }

  @autobind
  lockCurrentPage() {
    this.setState({
      isCurrentVideosPageLocked: true,
    });
  }

  @autobind
  unlockCurrentPage() {
    this.setState({
      isCurrentVideosPageLocked: false,
    });
  }

  render() {
    const {
      currentVideosPageNumber,
      videoIdsByPageNumber,
      containerWidth,
      onSlideToPrev,
      onSlideToNext,
    } = this.props;

    const { isCurrentVideosPageLocked } = this.state;

    return (
      <section styleName="container">
        <ContentSlider width={containerWidth}
                       onTransitionStart={this.lockCurrentPage}
                       onTransitionEnd={this.unlockCurrentPage}
                       currentPageNumber={currentVideosPageNumber}>
          <PageList pageWidth={containerWidth}
                    currentPageNumber={currentVideosPageNumber}
                    itemsByPageNumber={videoIdsByPageNumber}
                    renderItem={this.renderVideoItem} />
        </ContentSlider>
        <Nav prevButtonClassName={styles['prev-button']}
             nextButtonClassName={styles['next-button']}
             onPrevClick={onSlideToPrev}
             onNextClick={onSlideToNext}
             isDisabled={isCurrentVideosPageLocked}
             isPrevVisible={this.isPrevPageVisible}
             isNextVisible={this.isNextPageVisible} />
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/components/videos/videos.js